import { createPortal } from "react-dom";
import { useContext, useMemo, ReactNode, ReactPortal, RefObject, createContext } from "react";

export const PortalContext = createContext<{
    parentElementRef?: RefObject<HTMLElement>;
    fixed?: boolean;
}>(null);

export function usePortal(
    id: string,
    classes: Array<string> = [],
): (jsx: ReactNode) => ReactPortal {
    const context = useContext(PortalContext);
    return useMemo(() => {
        return (jsx: ReactNode) => {
            const contextualParentElement = context && context.parentElementRef && context.parentElementRef.current;
            const parent = contextualParentElement || document.body;

            let target: Element;
            let curNode = parent.lastElementChild;
            while (curNode !== parent.firstElementChild) {
                if (curNode.hasAttribute("data-portalid") && curNode.getAttribute("data-portalid") === id) {
                    target = curNode;
                    break;
                }
                curNode = curNode.previousElementSibling;
            }

            if (!target) {
                target = document.createElement("div");
                target.setAttribute("data-portalid", id);
                for (const className of classes) {
                    target.classList.add(className);
                }
                parent.appendChild(target);
            }

            return createPortal(jsx, target);
        };
    }, [context]);
}
